import { defineComponent as _defineComponent } from 'vue'
import { httpRequest } from '@/apis/request'
import { deleteUserAccessToken } from '@/apis/userAccessToken'
import gBaseModal from '@/components/g-base-modal.vue'
import { showSyncModal } from '@/components/syncmodal'
import { translateLang } from '@/data/i18n/translateLang'
import { message } from 'ant-design-vue'
import { ref } from 'vue'

import MAddModal from './components/m-add-modal.vue'
import MPreviewModal from './components/m-preview-modal.vue'
import { columns } from './data'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const yTableRef = ref<any>(null)
const isShowAddModal = ref(false)
const isShowPreviewModal = ref(false)

/** @description 令牌预览数据 */
const previewData = ref({
  name: '',
  expire_time: '',
  key: '',
})
/** @description 表格数据源 */
const dataSource = ref([])

/** @description 分页数据 */
const pagination = ref({
  total: 0,
})

/** @description 打开添加弹窗 */
function handleOpenAddModal() {
  isShowAddModal.value = true
}

/**
 * @description 添加成功
 * @param data 返回数据
 */
function handleAddSuccess(data: any) {
  isShowAddModal.value = false
  yTableRef.value.refreshQuery('add')
  previewData.value = data
  isShowPreviewModal.value = true
  message.success(translateLang('添加成功'))
}

/** @description 删除令牌 */
async function handleDelete(data: any) {
  const { status: flag } = await showSyncModal({
    modalComponent: gBaseModal,
    contain: translateLang('确定要删除该令牌吗？'),
  })
  if (!flag) return
  const { status, msg } = await deleteUserAccessToken(data.id)
  if (status !== 1) {
    return message.error(msg)
  }
  message.success(msg)
  yTableRef.value.refreshQuery('del')
}

/** @description 处理表格数据获取时的内置转换 */
function handleTransformTableData(data: any) {
  pagination.value.total = data.total
  return data.data?.data ?? []
}

return { __sfc: true,yTableRef, isShowAddModal, isShowPreviewModal, previewData, dataSource, pagination, handleOpenAddModal, handleAddSuccess, handleDelete, handleTransformTableData, httpRequest, translateLang, MAddModal, MPreviewModal, columns }
}

})